import { createContext, Dispatch } from 'react';

import { User, AuthAction } from 'reducers/authReducer/authReducer.types';

export interface AuthContextType {
  user: User;
  environment: string;
  authDispatch: Dispatch<AuthAction>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  environment: null,
  authDispatch: () => {},
});
